export enum FirestoreAuthErrorsEnum {
  invalidCredential = 'auth/invalid-credential',
  invalidVerificationCode = 'auth/invalid-verification-code',
  invalidVerificationId = 'auth/invalid-verification-id',
  userDisabled = 'auth/user-disabled',
  userNotFound = 'auth/user-not-found',
  accountExistsWithDifferentCredential = 'auth/account-exists-with-different-credential',
  operationNotAllowed = 'auth/operation-not-allowed',
  emailAlreadyInUse = 'auth/email-already-in-use',
  credentialAlreadyInUse = 'auth/credential-already-in-use',
  noSuchProvider = 'auth/no-such-provider',
  providerAlreadyLinked = 'auth/provider-already-linked',
  wrongPassword = 'auth/wrong-password',
  authUnknown = 'auth/unknown',
  invalidEmail = 'auth/invalid-email',
  userTokenExpired = 'auth/user-token-expired',
  userMismatch = 'auth/user-mismatch',
  tenantIdMismatch = 'auth/tenant-id-mismatch',
  nullUser = 'auth/null-user',
  requiresRecentLogin = 'auth/requires-recent-login',
  weakPassword = 'auth/weak-password',
  popupClosedByUser = 'auth/popup-closed-by-user',
  invalidPhoneNumber = 'auth/invalid-phone-number',
  tooManyRequests = 'auth/too-many-requests',
  quotaExceeded = 'auth/quota-exceeded',
  networkRequestFailed = 'auth/network-request-failed',
  captchaCheckFailed = 'auth/captcha-check-failed',
  missingPhoneNumber = 'auth/missing-phone-number',
  codeExpired = 'auth/code-expired',
  sessionExpired = 'auth/session-expired',
  internalError = 'auth/internal-error',
}

